import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

import { Link, Text } from '@nerdwallet/currency';
import nds from '@nerdwallet/base-styles/classes';

import BulletedList from '../bulleted-list/bulleted-list';
import Row from '../row/row';

import './edu-details-section.less';

const EduDetailsSection = ({ data }) => {
  const name = get(data, 'name', '');

  return (
    <Row
      className={classNames([
        'edu-details-section',
        nds(
          'padding-all-4',
          'border-top-1',
          'border-neutral-light',
          'display-flex',
          'flex-direction-column',
          'flex-direction-row--wide'
        ),
      ])}
    >
      <div
        className={nds(
          'width-50--wide',
          'padding-bottom-3',
          'padding-bottom-0--wide',
          'padding-right-4--wide'
        )}
      >
        <Text bold>Qualifications</Text>
        <BulletedList
          bullets={get(data, 'details.qualifications_bullets.value', [])}
          className={nds('padding-bottom-1')}
        />
        <Text bold>NerdWallet Editor Review</Text>
        <Link href={get(data, 'details.review_link.value', [])}>
          <Text small className={nds('padding-bottom-2')}>
            {name} review
          </Text>
        </Link>
        <Text bold>Available Term Lengths</Text>
        <Text small>
          {get(data, 'details.available_term_lengths.value', '')}
        </Text>
      </div>
      <Row
        columns="2"
        className={nds(
          'border-top-1',
          'border-top-0--wide',
          'border-left-1--wide',
          'width-50--wide',
          'border-neutral-light',
          'padding-top-3',
          'padding-top-0--wide',
          'padding-left-4--wide'
        )}
      >
        <div>
          <Text bold>Pros</Text>
          <BulletedList bullets={get(data, 'details.pros_bullets.value', [])} />
        </div>
        <div>
          <Text bold>Cons</Text>
          <BulletedList bullets={get(data, 'details.cons_bullets.value', [])} />
        </div>
      </Row>
    </Row>
  );
};

EduDetailsSection.propTypes = {
  data: PropTypes.object,
  viewConfig: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default EduDetailsSection;
